import { createSlice } from "@reduxjs/toolkit";
import { getMessageHistory } from "./thunk";

const initialState = {
  messageHistory: [],
};

const chatsSlice = createSlice({
  name: "chatsSlice",
  initialState: { ...initialState },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMessageHistory.pending, () => {})
      .addCase(getMessageHistory.fulfilled, (state, action) => {
        state.messageHistory = action.payload?.data || {};
      })
      .addCase(getMessageHistory.rejected, () => {});
  },
});

export default chatsSlice.reducer;
